import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/smc/bg.png'
import _imports_1 from '@/assets/image/smc/success.png'
import _imports_2 from '@/assets/image/smc/default.png'
import _imports_3 from '@/assets/image/smc/hover.png'
import _imports_4 from '@/assets/image/smc/active.png'


const _withScopeId = n => (_pushScopeId("data-v-1dbb1e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "flex-col-ter",
  style: {"padding-top":"42px","background":"linear-gradient(180deg,#bfebc1 -40%,#fff 30%)","margin-top":"-47px","border-radius":"0 0 30px 30px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"60px","margin":"10px 0 10px","z-index":"10"},
  src: _imports_1,
  alt: "",
  class: "rel"
}, null, -1))
const _hoisted_5 = { class: "text-h3" }
const _hoisted_6 = { style: {"width":"100%"} }
const _hoisted_7 = {
  class: "container prompt",
  style: {"margin":"15px auto 10px","width":"426px"}
}
const _hoisted_8 = { class: "text-h4" }
const _hoisted_9 = { class: "text-s1" }
const _hoisted_10 = { class: "flex invite" }
const _hoisted_11 = {
  class: "fx-1",
  style: {"letter-spacing":"4px"}
}
const _hoisted_12 = { class: "flex invite" }
const _hoisted_13 = {
  class: "fx-1 line--only",
  style: {"font-size":"12px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "default"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_17 = { class: "abs" }
const _hoisted_18 = {
  key: 1,
  class: "flex-col-ter rel",
  style: {"padding":"27px 40px 0","text-align":"center","z-index":"10","background":"linear-gradient(180deg,#bfebc1 -40%,#fff 30%)","margin-top":"-27px","border-radius":"0 0 30px 30px"}
}
const _hoisted_19 = {
  class: "text-h3-d",
  style: {"margin":"72px 0 20px 0"}
}
const _hoisted_20 = {
  class: "text-h4",
  style: {"margin-bottom":"58px"}
}
const _hoisted_21 = { style: {"font-size":"18px"} }
const _hoisted_22 = { style: {"font-size":"18px"} }
const _hoisted_23 = {
  class: "text-h3",
  style: {"color":"#008060","font-size":"24px"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  class: "text-h3",
  style: {"color":"#008060","font-size":"24px"}
}
const _hoisted_26 = {
  class: "flex-bwn",
  style: {"padding-left":"9px"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "default"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_30 = { class: "abs fontSize-14" }

import { ref, computed, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import { smc, memberNames, krOrUkMemberNames, Site } from '@/common/const'
import SvgIcon from '../icons/SvgIcon.vue'
import { useRtfix, useSite2Station } from '@/store'
import { getPromoFlag, changePromoFlag } from '@/apis/smc'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const token = store.getters.token

const visible = ref(false)
const isPrompt = ref(false)
const isNewone = ref(false)
const promoType = ref('PRO')
const loaded = ref(false)
const onload = () => {
  loaded.value = true
}

const newoneinfo = reactive({
  promoName: '',
  vipTime: '',
  vipLevel: ''
})

const invitecode = ref('114514')
const inviteurl = computed(() => {
  return location.origin + '/signup?channel=0&code=' + invitecode.value
})

const copy = (str: string) => {
  navigator.clipboard.writeText(str)
}

const jump = () => {
  changeStatus(() => {
    visible.value = false
    window.open(location.origin + smc.getUrl())
  })
}
const stationCode = useSite2Station()
if (token) {
  getPromoFlag({ firstLogin: true, firstReward: true }).then(res => {
    if (res.data?.popFirstLogin) {
      if (res.data.isPromo) {
        // 成为推广者
        visible.value = true
        isPrompt.value = res.data.isPromo
        invitecode.value = res.data.invitationCode
        promoType.value = res.data.promoType
      }
    }
    if (res.data?.popFirstReward) {
      if (res.data.promoHandselVipLevel) {
        // 被推广者首次登陆
        visible.value = true
        isNewone.value = true
        newoneinfo.promoName = res.data.superCustomerName
        newoneinfo.vipTime = res.data.promoHhandselTimeLength
        // 需要区分，如果是日本站保持一致，如果是其他两个站点，则只有三个会员等级
        const newMemberNames = stationCode === Site.JA ? memberNames : krOrUkMemberNames
        newoneinfo.vipLevel = newMemberNames[res.data.promoHandselVipLevel as 'LEVEL1']
      }
    }
  })
}

// 关闭调用修改状态
const changeStatus = (fn: any) => {
  if (!isNewone.value && !isPrompt.value) return
  changePromoFlag({
    popType: isNewone.value ? 'FIRST_REWARD' : isPrompt.value ? 'FIRST_LOGIN' : ''
  }).then(() => {
    fn && fn()
  })
}
const close = () => {
  changeStatus(() => {
    visible.value = false
    if (isPrompt.value && promoType.value !== 'PRO') {
      // 普通推广者关闭按钮时跳转/smc/manage/MyPromotion
      location.href = location.origin + '/smc/manage/MyPromotion?lang=' + localStorage.__lang__
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    width: isPrompt.value ? '500px' : '560px',
    "close-on-click-modal": false,
    "show-close": false,
    "custom-class": "smc-modal"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        (isNewone.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "abs",
              src: _imports_0,
              alt: "",
              style: {"width":"586px","top":"-34px","z-index":"12"},
              onload: onload
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (isPrompt.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "abs",
                  src: _imports_0,
                  alt: "",
                  style: {"width":"523px","top":"-34px","z-index":"12","left":"0"},
                  onload: onload
                }),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(`恭喜您已成为THE CKB${promoType.value === 'PRO' ? '专业' : '普通'}推广者`)), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('我的专属推广码')), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('复制邀请码或者链接，即可进行推广')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(invitecode.value), 1),
                        _createVNode(_component_el_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (copy(invitecode.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('复制')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(inviteurl)), 1),
                        _createVNode(_component_el_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (copy(_unref(inviteurl))))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('复制')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: "btn-open rel",
                    onClick: jump,
                    style: {"margin-top":"-8px"}
                  }, [
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('开启推广之旅')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (isNewone.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('欢迎来到THE CKB！')), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('成功邀请了您，恭喜您获得')), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, " 「" + _toDisplayString(_unref(t)(_unref(newoneinfo).vipLevel)) + "」 ", 1),
                    (_unref(stationCode) === _unref(Site).EN)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Free trial for "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(newoneinfo).vipTime), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('天会员免费试用！').replace('X', '')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_el_button, {
                    class: "jump-vip",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (changeStatus(() => { _ctx.$router.push(_unref(useRtfix)('VipLevel')) })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('查看会员')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "btn-open rel",
                    onClick: jump
                  }, [
                    _hoisted_27,
                    _hoisted_28,
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('我也要推广')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "abs modalclose",
          onClick: close
        }, [
          _createVNode(SvgIcon, { name: "关闭弹窗" })
        ])
      ], 512), [
        [_vShow, loaded.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})